/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import { AccesosProvider } from "../Catalogos/AccesosContext"
import { ArticulosProvider } from "../Catalogos/ArticulosContext"
import { ClientesProvider } from "../Catalogos/ClientesContext"
import { ProveedoresProvider } from "../Catalogos/ProveedoresContext"
import { AlmacenesExhibidoresProvider } from "../Catalogos/AlmacenesExhibidoresContext"
import { CorridasProvider } from "../Catalogos/CorridasContext"

export const AllCatalogosProvider = (props) => (
    <AccesosProvider>
        <ArticulosProvider>
            <ClientesProvider>
                <ProveedoresProvider>
                    <AlmacenesExhibidoresProvider>
                        <CorridasProvider>
                            {props.children}
                        </CorridasProvider>
                    </AlmacenesExhibidoresProvider>
                </ProveedoresProvider>
            </ClientesProvider>
        </ArticulosProvider>
    </AccesosProvider>
);